import { StyledLink } from '@/components/Link/Link.styles';
import tw, { styled } from 'twin.macro';

export const StyledButton = styled(StyledLink.withComponent('button'))`
  ${tw`w-full`}
`;
